// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_AVATAR = "Naozaj chce\u0161 zmaza\u0165 svoju profilov\u00fa fotku?";
export const PB_POST_HAS_BEEN_SUBMITTED = "Pr\u00edspevok bol \u00faspe\u0161ne uverejnen\u00fd.";
export const USER_ALREADY_LIKED = "Pou\u017e\u00edvate\u013eka je pridan\u00e1 k ob\u013e\u00faben\u00fdm.";
export const USER_ALREADY_UNLIKED = "Pou\u017e\u00edvate\u013eka bola odobran\u00e1 z ob\u013e\u00faben\u00fdch.";
export const USER_BLOCKED_SUCCESS = "Pou\u017e\u00edvate\u013e bol zablokovan\u00fd";
export const USER_LIKED = "Pou\u017e\u00edvate\u013eka bola pridan\u00e1 k ob\u013e\u00faben\u00fdm.";
export const USER_UNBLOCKED_SUCCESS = "Pou\u017e\u00edvate\u013e bol odblokovan\u00fd";
export const USER_UNLIKED = "Pou\u017e\u00edvate\u013eka bola odobran\u00e1 z ob\u013e\u00faben\u00fdch.";
